import * as types from './types'
const mutations = {
  [types.CURRENT_ADDRESS] (state, obj) {
    state.currentAddress = obj
  },
  [types.SHOPCART_NUM] (state, number) {
    state.shopCartNum = number
  },
  [types.EDIT_ADDRESS] (state, obj) {
    state.editAddress = obj
  },
  [types.CATEGORY_LIST] (state, val) {
    state.categoryList = val
  },
  [types.SLIDE_BAR_SHOW_FLAG] (state, boolen) {
    state.slideBarShowFlag = boolen
  },
  [types.SWIPER_INDEX] (state, number) {
    state.swiperIndex = number
  },
  [types.GOODS_DETAIL] (state, obj) {
    state.goodsDetail = obj
  },
  [types.GOODS_COMMENT] (state, obj) {
    state.goodsComment = obj
  },
  [types.TYPE_ID] (state, obj) {
    state.typeId = obj
  },
  [types.IS_IPX] (state, obj) {
    state.isIpx = obj
  },
  [types.HOTEL_CODE](state, obj) {
    state.hotelCode = obj
  },
  [types.IS_OPENSHARE](state, boolen) {
    state.isOpenShare = boolen
  },
  [types.KEEP_ALIVE](state, obj) {
    state.keepAlive = obj
  },
  [types.SHOPCART_NUM] (state, obj) {
    state.shopcartNum = obj
  },

}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js